module.exports = __webpack_public_path__ + "static/media/10.a97c0da0.png";